'use client';

import FaIcon, { faChevronDown, faChevronUp } from '@/components/icon/FaIcon/FaIcon';
import Accordion from '@/components/ui/Accordion/Accordion';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useState } from 'react';
import styles from './LotteryDetailDescription.module.scss';

function LotteryDetailDescription({
  precautions,
  description,
  shippingDescription,
  benefitDescription,
  wchanceAbout,
  descriptionTitle = 'くじ詳細',
  isDefaultOpen = false,
}: {
  precautions: string;
  description: string;
  shippingDescription: string;
  benefitDescription: string;
  wchanceAbout?: string;
  descriptionTitle?: string;
  isDefaultOpen?: boolean;
}) {
  const [isOpened, setIsOpened] = useState(isDefaultOpen);
  const toggleAccordion = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsOpened(!isOpened);
  };
  const isDescriptionHidden = !description || description.trim() === '' || description === '<p>　</p>';
  return (
    <div className={styles.componentStyle}>
      <p className={`${utilsStyles.textLarge} ${utilsStyles.textBold}`}>{descriptionTitle}</p>
      <hr className={styles.itemHr} />
      <div className={utilsStyles.textSmall}>
        <Accordion isOpened={isOpened} startHeight={50}>
          <div
            className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml} ${isDescriptionHidden ? styles.hidden : ''}`}
            // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {precautions && (
            <>
              <p
                className={`${isDescriptionHidden ? utilsStyles.hidden : utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}
              >
                <b>注意事項</b>
              </p>
              <div
                className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                dangerouslySetInnerHTML={{ __html: precautions }}
              />
            </>
          )}
          {shippingDescription && (
            <>
              <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
                <b>配送について</b>
              </p>
              <div
                className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                dangerouslySetInnerHTML={{ __html: shippingDescription }}
              />
            </>
          )}
          {benefitDescription && (
            <>
              <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
                <b>特典について</b>
              </p>
              <div
                className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                dangerouslySetInnerHTML={{ __html: benefitDescription }}
              />
            </>
          )}
          {wchanceAbout && (
            <>
              <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textMedium}`}>
                <b>Wチャンス賞について</b>
              </p>
              <div
                className={`${utilsStyles.textPrewrap} ${utilsStyles.textHtml}`}
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                dangerouslySetInnerHTML={{ __html: wchanceAbout }}
              />
            </>
          )}
        </Accordion>

        <div className={utilsStyles.centered}>
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a
            href='#'
            onClick={(e) => {
              toggleAccordion(e);
            }}
          >
            {isOpened ? '閉じる' : 'もっと見る'}
          </a>
          {isOpened ? <FaIcon icon={faChevronUp} /> : <FaIcon icon={faChevronDown} />}
        </div>
      </div>
    </div>
  );
}

export default LotteryDetailDescription;
